export const INIT = 'STRONA_STUDENTA/INIT';

export const GET_LEFT_PANEL_DATA_START = 'STRONA_STUDENTA/GET_LEFT_PANEL_DATA_START';
export const GET_DATA_START = 'STRONA_STUDENTA/GET_DATA_START';
export const GET_DATA_NEXT_PAGE_START = 'STRONA_STUDENTA/GET_DATA_NEXT_PAGE_START';

export const COLUMNS_SAVE_USER_SETUP_START = 'STRONA_STUDENTA/COLUMNS_SAVE_USER_SETUP_START';
export const COLUMNS_GET_CONFIG_START = 'STRONA_STUDENTA/COLUMNS_GET_CONFIG_START';

export const RECORD_GET_DETAILS_START = 'STRONA_STUDENTA/RECORD_GET_DETAILS_START';

export const REFRESH_DATA_START = 'STRONA_STUDENTA/REFRESH_DATA_START';
export const REFRESH_SELECTED_DATA_START = 'STRONA_STUDENTA/REFRESH_SELECTED_DATA_START';

// export const SYNC_DATA_WITH_CACHE_START = 'STRONA_STUDENTA/SYNC_DATA_WITH_CACHE_START';
